import { CREATE_PRODUCER } from "./Constants"

export const createProducer = ( dispatch, params ) => {
  dispatch({ type: CREATE_PRODUCER, payload: params })
}